import Register from "../src/register/Register";

export default function RegisterPage(props) {
  return <Register {...props}></Register>;
}
